import React, { PropsWithChildren } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { PAGE_TAB_TITLE_LIST } from '../../../constants/service/common/pageConstants';
import './PageTemplate.scss';

interface PageTemplateProps {
  pageName?: string;
}

const PageTemplate = (props: PropsWithChildren<PageTemplateProps>) => {
  const { pageName, children } = props;
  const location = useLocation();

  return (
    <div className="page-template">
      <Helmet>
        <title>{PAGE_TAB_TITLE_LIST[location.pathname] || 'AMONDZ ADMIN'}</title>
      </Helmet>

      {!!pageName && <div className="page-title">{pageName}</div>}

      <main id="page-template-main">{children}</main>
    </div>
  );
};

export default PageTemplate;
